import type { OptionTabGroup } from '@morpho-org/ui-v6/client'

import type { SectionConfig } from '@/hooks/useSectionScrollSpy'

export type VaultSubTabs =
  | 'overview'
  | 'allocation'
  | 'performance'
  | 'risk'
  | 'activity'
  | 'yourPosition'

export const VAULT_SUB_TAB_OPTIONS: OptionTabGroup<VaultSubTabs>[] = [
  {
    label: 'Overview',
    value: 'overview'
  },
  {
    label: 'Allocation',
    value: 'allocation'
  },
  {
    label: 'Performance',
    value: 'performance'
  },
  {
    label: 'Risk',
    value: 'risk'
  },
  {
    label: 'Activity',
    value: 'activity'
  },
  {
    label: 'Your Position',
    value: 'yourPosition'
  }
]

export const VAULT_SECTION_CONFIG: SectionConfig<VaultSubTabs>[] = VAULT_SUB_TAB_OPTIONS.map(o => ({
  id: o.value,
  label: o.label,
  requiresConnectedWallet: o.value === 'yourPosition'
}))
